const {validateEmail} = require("./validate-email");

const email = {
    name: "email",
    validate: validateEmail,
};
exports.email = email;
